<script>
import store from '@state/store'
import { Empty } from 'ant-design-vue'

export default {
  props: {
    containers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeIndex: null,
      loading: store.getters['appstream/isLoading'],
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE
  },
  mounted() {
    store.commit('appstream/SET_LOADING', false)
  },
  methods: {
    selectVM(container, i) {
      if (store.getters['appstream/isLoading']) {
        return
      }
      this.activeIndex = i
      store.commit('appstream/SET_APPSTREAM', container)
    },
    getFleetStatus(container) {
      if (container?.state === 'STOPPED') {
        return `🔴 `
      } else if (
        container?.state === 'STARTING' ||
        container?.state === 'STOPPING'
      ) {
        return `🟡 `
      } else {
        return `🟢 `
      }
    },
  },
}
</script>

<template>
  <div v-if="containers.length" class="appContainer">
    <a-card
      v-for="(container, i) in containers"
      :key="i"
      hoverable
      style="min-width: 300px; margin: 0 0.6rem"
      :class="{ active: i === activeIndex }"
      @click="selectVM(container, i)"
    >
      <a-card-meta
        :title="container.name + ' · ' + container.meta.os"
        :class="{ active: i === activeIndex }"
        :description="getFleetStatus(container) + ' ' + container.meta.location"
      >
        <a-avatar slot="avatar" :src="container.meta.imageUrl" />
      </a-card-meta>
    </a-card>
  </div>
  <div v-else class="appContainer--empty">
    <a-empty :image="simpleImage" description="No Containers Assigned" />
  </div>
</template>

<style lang="scss">
@import '@design';

.appContainer {
  display: flex;
  width: 100%;
  padding: 0 !important;
  .ant-card-meta-title,
  .ant-card-meta-description {
    text-align: left;
  }
  .ant-card-meta {
    &.active {
      border: 0;
    }
  }
  &--empty {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .active {
    border: 1px solid #1890ff;
  }
}

.note {
  font-size: 0.8rem !important;

  button {
    margin-left: 8px;
  }
}
</style>
